import _regeneratorRuntime from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/@babel/runtime-corejs2/helpers/esm/regeneratorRuntime.js";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es6.number.constructor";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import applyForm from "./applyForm.vue";
import { getCustomerList } from '@/views/cardSystem/customer/api/index';
import { getMyReviewList } from "../api";
export default {
  components: {
    applyForm: applyForm
  },
  props: {
    reviewCount: {
      type: [String, Number],
      default: 0
    }
  },
  data: function data() {
    return {
      companyList: [],
      searchForm: {
        status: [],
        type_of_demand: [],
        customer_id: null,
        pageSize: 20,
        page: 1
      },
      listData: [],
      listPages: {
        currentPage: 1,
        totalCount: 0
      },
      applyFormVisible: false,
      applyFormType: 'view',
      selectedId: null
    };
  },
  created: function created() {
    if (this.$hasBtnRoles('/user/project-delivery/my-review')) {
      this.getCompanyList();
      this.getlist();
    }
  },
  methods: {
    getCompanyList: function getCompanyList(val) {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return getCustomerList({
                page_size: 200,
                name: val || '',
                is_delete: 0
              });
            case 2:
              res = _context.sent;
              _this.companyList = res.data.list;
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    getlist: function getlist() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var res;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return getMyReviewList(_this2.searchForm);
            case 2:
              res = _context2.sent;
              _this2.listData = res.data.data;
              _this2.listPages = res.pages;
              // 更新父组件的审核数量
              _this2.$emit('update:reviewCount', res.data.count);
            case 6:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    // 翻页
    handlePageChange: function handlePageChange(page) {
      this.searchForm.page = page;
      var dom = document.getElementById('searchDom');
      dom.scrollIntoView();
      this.getlist();
    },
    sizeChange: function sizeChange(size) {
      this.searchForm.pageSize = size;
      this.searchForm.page = 1;
      this.getlist();
    },
    resetList: function resetList() {
      this.searchForm.page = 1;
      this.getlist();
    },
    handleClose: function handleClose() {
      this.getlist();
    },
    viewDetail: function viewDetail(id) {
      this.selectedId = id;
      this.applyFormType = 'view';
      this.applyFormVisible = true;
    },
    approve: function approve(id) {
      this.selectedId = id;
      this.applyFormType = 'approve';
      this.applyFormVisible = true;
    }
  }
};